let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gERCO"), load("jjWia")]).then(() => parcelRequire('c8BWz'));